import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const GetRateCardDetails = async (searchData) => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Account/GetRateCardDetails?searchData=${searchData}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}